import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { format, utcToZonedTime } from 'date-fns-tz';
import Tippy from '@tippyjs/react';
import ReactModal from 'react-modal';
import { TbSearch } from 'react-icons/tb';
import InputMask from 'react-input-mask';
import { findManagers, findPlayer, getLinkedIndicators } from 'services/profile.service';
import { LinkedIndicators_Indicadores, User } from 'types/user';
import { RiCloseLine, RiSearchLine } from 'react-icons/ri';
import { useAuth } from 'context/AuthContext';
import Box from 'components/ui/box';
// import { actionLog } from 'services/actionlog.service';
import { BiInfoCircle } from 'react-icons/bi';
import {
  deleteMissionFeedback,
  getPlayerInfo,
  getServerTime,
  getTaskById,
  getTaskByIdEcoa,
  sendNotificationTask,
  sendPreferenceNotification,
  submitTask,
  submitTaskEcoa,
  updateTask,
  updateTaskEcoa,
  verifyTask,
} from 'services/dashboard.service';
import { UserAvatar } from 'components/user-avatar';
import { IoMdCloseCircle } from 'react-icons/io';
import { MdOutlineExpandMore, MdOutlineExpandLess } from 'react-icons/md';

import { toast } from 'react-toastify';
import Modal from '../Modal/Index';
import { IoClose } from 'react-icons/io5';
import CustomSelect from 'components/custom-select';
import { ineligibleIdsArray } from 'services/utils';
import { AiOutlineEdit } from 'react-icons/ai';
import TextEditor from 'components/text-editor';
import { useModal } from 'context/ModalContext';
import { useHelp } from 'context/HelpContext';
import { getPerformanceCategory } from 'utils/helpers';
import { PERIOD_END_MIN, PERIOD_START_MIN, isPeriodEndValid, isPeriodStartValid } from 'utils/delivery-period';

import './style.scss';
import FeedbackImg from 'assets/img/comportamento/bg-feedback-moedas.png';
import { getNecs, getUors, getDemandantes } from 'services/realizacao.service';
import ModalAcessivel from 'components/modal-acessivel';
import { NotFound } from 'pages/NotFound';

const maskTemplate = 'F9999999';

const indicadores = [
  {
    nome: 'Autodesenvolvimento',
    cod: 'Autodesenvolvimento',
  },
  {
    nome: 'Bem-estar',
    cod: 'Bem-estar',
  },
  {
    nome: 'Sustentabilidade',
    cod: 'Sustentabilidade',
  },
  {
    nome: 'Cultura',
    cod: 'Cultura',
  },
];

export default function AcaoCreate() {
  const navigate = useNavigate();
  const params = useParams();

  const { user, userInfo, refreshUser, currentCycle, cycles } = useAuth();
  const { helpData } = useHelp();

  const [intervalId, setIntervalId] = useState<any>(null);

  const searchRef = useRef<any>();
  const messageRef = useRef<any>();
  const titleRef = useRef<any>();
  const periodStartRef = useRef<any>();
  const periodEndRef = useRef<any>();

  const [isOpen, setIsOpen] = useState(true);
  const [editing, setEditing] = useState(true);

  const [searchResults, setSearchResults] = useState<User[]>([]);
  const [target, setTarget] = useState<User[]>();
  const [openTargetAlert, setOpenTargetAlert] = useState(false);
  const { showModal } = useModal();
  const [showModalTutorial, setshowModalTutorial] = useState(false);

  const [necsList, setNecsList] = useState<any>([]);
  const [demandanteList, setDemandanteList] = useState<any>([]);
  const [needNec, setNeedNec] = useState<any>([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isEmptyName, setIsEmptyName] = useState(false);
  const [isAlreadySelectedInList, setIsAlreadySelectedInList] = useState(false);
  const [showDemandante, setShowDemandante] = useState(false);
  const [necIsSearched, setNecIsSearched] = useState(false);
  const [demandanteValue, setDemandanteValue] = useState<any>([]);
  const [selectedNec, setSelectedNec] = useState<any>([]);

  const [teamDistribution, setTeamDistribution] = useState<any>({});

  const [periodStart, setPeriodStart] = useState<any>();
  const [periodEnd, setPeriodEnd] = useState<any>();
  const [nec, setNec] = useState<any>();

  const [title, setTitle] = useState<string>();
  const [titleLength, setTitleLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [message, setMessage] = useState<string>();
  const [messageLength, setMessageLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [resultMessage, setResultMessage] = useState<string>();
  const [resultLength, setResultLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [indicator, setIndicator] = useState<{ label: string; value: number | string } | undefined>();
  const [indicatorsList, setIndicatorsList] = useState<LinkedIndicators_Indicadores[] | undefined>();

  const [searchingCurrentUser, setSearchingCurrentUser] = useState(false);
  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [step, setStep] = useState(0);

  const [submitError, setSubmitError] = useState<string>();

  const [mask, setMask] = useState('');

  const [showModalAlert, setShowModalAlert] = useState<any>(false);

  const [currentTask, setCurrentTask] = useState<any>();
  const [maxMembersWithoutApproval, setMaxMembersWithoutApproval] = useState<number>(20);
  const [maxMembers, setMaxMembers] = useState<number | undefined>();

  const [initialManager, setInitialManager] = useState<any>();
  const [searchManager, setSearchManager] = useState<string>('');
  const [searchResultsManager, setSearchResultsManager] = useState<User[]>([]);

  const [minDate, setMinDate] = useState<string>();
  const [maxDate, setMaxDate] = useState<string>();
  const [ariaLabel, setAriaLabel] = useState('');

  const [hasOtherType, setHasOtherType] = useState(false);

  const modalRef = useRef<HTMLDivElement>(null);
  const lastFocusedElementRef = useRef<HTMLElement | null>(null);

  const [usersNotification, setUsersNotification] = useState<string[]>([]);
  const [usersNotificationPreference, setUsersNotificationPreference] = useState<string[]>([]);

  ReactModal.setAppElement('#modal');

  const minTitleLength = 0;
  const maxTitleLength = 150;

  const minMessageLength = 0;
  const maxMessageLength = 600;

  const minResultLength = 0;
  const maxResultLength = 600;

  const minMessageTarget = 1;
  const maxMessageTarget = 200;

  ReactModal.setAppElement('#modal');

  const maxMembersByProfile = useMemo(() => {
    let maxM = 0;

    if (
      !!userInfo?.ro?.match(/(3GUE|2GUT|2GCA|2GUA)/gi) &&
      (typeof maxMembers !== 'number' || (typeof maxMembers === 'number' && maxMembers <= 30))
    ) {
      maxM = 30;
    } else if (
      !!userInfo?.ro?.match(/(2GUE|1GUT|1GUA|1GCA)/gi) &&
      (typeof maxMembers !== 'number' || (typeof maxMembers === 'number' && maxMembers <= 50))
    ) {
      maxM = 50;
    } else if (
      !![3003, 4005, 4007].includes(userInfo?.cod_funcao || 0) &&
      (typeof maxMembers !== 'number' || (typeof maxMembers === 'number' && maxMembers <= 100))
    ) {
      maxM = 100;
    } else if (!![3002].includes(userInfo?.cod_funcao || 0)) {
      maxM = 1000000;
    } else {
      if (typeof maxMembers === 'number') {
        maxM = maxMembers;
      } else {
        maxM = maxMembersWithoutApproval;
      }
    }

    return maxM;
  }, [maxMembers, maxMembersWithoutApproval, userInfo]);

  const teamApproval = () => {
    const obj = {
      showAlert: false,
      showPending: false,
      isApproved: false,
      blockAdd: false,
      expired: false,
      rejected: false,
      taskStep: cycles?.find(x => {
        if (!!currentTask?._id) {
          return currentTask.created >= x.date_start && currentTask.created <= x.date_finish;
        } else {
          const date = +new Date();
          return date >= x.date_start && date <= x.date_finish;
        }
      }),
    };

    if (!!cycles && !!userInfo) {
      if (params?.id && params.id === 'cadastrar' && Array.isArray(target) && target.length > maxMembersWithoutApproval) {
        obj.showAlert = true;
      } else if (params?.id && params.id !== 'cadastrar') {
        if (!!currentTask?._id) {
          if (obj.taskStep?.status === 'open') {
            if (Array.isArray(target) && target.length > maxMembersWithoutApproval) {
              obj.showAlert = true;
            }

            if (currentTask.participants_approval?.status === 'pending') {
              obj.showPending = true;
            }

            if (currentTask.participants_approval?.status === 'approved') {
              obj.isApproved = true;
            }

            if (currentTask.participants_approval?.status === 'rejected') {
              obj.rejected = true;
            }
          } else if (obj.taskStep?.status === 'evaluation') {
            if (currentTask.participants_approval?.status === 'pending') {
              // obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembersWithoutApproval);
              obj.expired = true;
            } else if (currentTask.participants_approval?.status === 'approved') {
              obj.isApproved = true;
              // obj.blockAdd = !!(!maxMembers || (maxMembers && target?.length && target.length >= maxMembers));
            } else {
              // if (typeof maxMembers === 'number') {
              //   obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembers);
              // } else {
              //   obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembersWithoutApproval);
              // }
            }

            obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembersByProfile);

            if (currentTask.participants_approval?.status === 'rejected') {
              obj.rejected = true;
            }
          } else {
            obj.blockAdd = true;
          }
        } else {
          obj.blockAdd = true;
        }
      }
    } else {
      obj.blockAdd = true;
    }

    return obj;
  };

  function handleChange() {
    if (searchRef.current) {
      const value = searchRef.current.value.toUpperCase();
      if (value.length > 1) {
        if (value[0].toUpperCase() === 'F' && !isNaN(value[1])) {
          setMask(maskTemplate);
        } else {
          setMask('');
          if (value === '_______') {
            searchRef.current.value = '';
          }
        }
      } else {
        setMask('');
      }
    }
  }

  async function handleSearch(e?: any) {
    if (e) {
      e.preventDefault();
    }

    try {
      setOpenTargetAlert(false);
      const matricula = searchRef.current.value.replace('_', '');

      const targetOnList = target?.find(item => item._id === matricula);

      if (targetOnList) {
        setIsAlreadySelectedInList(true);
        setSearching(false);
        return;
      }

      setSearching(true);

      const result = await findPlayer(searchRef.current.value, true, true, true, true);

      const filteredResults = result.filter((item: any) => item._id !== user?._id);
      const isCurrentUser = result.filter((item: any) => item._id === user?._id);

      if (filteredResults) {
        setSearchResults(filteredResults);

        setIsEmpty(filteredResults?.length === 0 && matricula.startsWith('F') && matricula.length === 8);
        setIsEmptyName(filteredResults?.length === 0 && isCurrentUser.length === 0);
      }

      setSearching(false);
    } catch (e) {
      setSearching(false);
    }
  }

  async function handleSearchManager(e?: any) {
    if (e) {
      e.preventDefault();
    }

    try {
      setSearching(true);

      const result = await findManagers(searchManager, [0, 1, 2, 3, 4, 5], true, true);

      const filteredResults = result.filter((item: any) => item._id !== user?._id);

      setSearchResultsManager(filteredResults);

      setSearching(false);
    } catch (e) {
      setSearching(false);
    }
  }

  async function handleSubmit() {
    try {
      if (
        loading ||
        !message ||
        !resultMessage ||
        !userInfo ||
        !titleLength ||
        titleLength?.textLength < minTitleLength ||
        titleLength?.fullLength > maxTitleLength ||
        !messageLength ||
        messageLength?.textLength < minMessageLength ||
        messageLength?.fullLength > maxMessageLength
      )
        return;

      setLoading(true);

      let team: any = [];

      if (target) {
        team =
          target.map(item => {
            return {
              _id: item._id,
              cad_missao: item.extra?.cad_missao,
              cod_etapa: item.extra?.cod_etapa,
              funcao_localizacao: item.extra?.funcao_localizacao,
              message: item.message,
            };
          }) || [];
      }

      team = validateDistribution(team);

      // const managerOnTeam = await checkManagerOnTeam(
      //   params.id && params.id !== 'cadastrar' ? currentTask.owner : user?._id,
      //   team.map((x: { _id: any }) => x._id),
      // );

      if (params.id && params.id !== 'cadastrar') {
        const actualTask = { ...currentTask, ecoa: true };

        if (actualTask.status === 'rejeitado' && !!actualTask?.feedback?.length) {
          deleteMissionFeedback(actualTask._id);
        }

        team.forEach((obj: any) => {
          const currentTaskTeamUser = actualTask.team.find((x: { _id: any }) => x._id === obj._id);

          if (!!currentTaskTeamUser) {
            if (currentTaskTeamUser.cad_missao) {
              obj.cad_missao = currentTaskTeamUser.cad_missao;
            }

            if (currentTaskTeamUser.cod_etapa) {
              obj.cod_etapa = currentTaskTeamUser.cod_etapa;
            }

            if (currentTaskTeamUser.funcao_localizacao) {
              obj.funcao_localizacao = currentTaskTeamUser.funcao_localizacao;
            }
          }
        });

        // team.forEach((obj: any) => {
        //   const currentTaskTeamUser = currentTask.team.find((x: { _id: any }) => x._id === obj._id);

        //   if (!!currentTaskTeamUser?.requiresApproval) {
        //     obj.requiresApproval = currentTaskTeamUser.requiresApproval;

        //     if (typeof currentTaskTeamUser.approvedByManager !== 'undefined') {
        //       obj.approvedByManager = currentTaskTeamUser.approvedByManager;
        //     }
        //   } else {
        //     const managerOnTeamUser = managerOnTeam?.find(x => x.chave === obj._id);

        //     if (!!managerOnTeamUser && !!managerOnTeamUser.requiresApproval) {
        //       obj.requiresApproval = true;
        //     }
        //   }
        // });

        const taskStep = teamApproval().taskStep;
        const totalParticipantes = team?.length;
        const participants_approval: any = {
          total: totalParticipantes,
        };

        if (teamApproval().isApproved && maxMembers) {
          if (taskStep?.status === 'open') {
            if (totalParticipantes > maxMembers) {
              delete actualTask.maxPlayersNumber;

              if (totalParticipantes >= 21 && totalParticipantes <= 30) {
                // Autorização por RO 3GUE, 2GUT, 2GCA, 2GUA
                participants_approval.status = 'pending';
                participants_approval.type = 'ro';
                participants_approval.values = '3GUE,2GUT,2GCA,2GUA,2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
              } else if (totalParticipantes >= 31 && totalParticipantes <= 50) {
                // Autorização por RO 2GUE, 1GUT, 1GUA ou 1GCA
                participants_approval.status = 'pending';
                participants_approval.type = 'ro';
                participants_approval.values = '2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
              } else if (totalParticipantes >= 51 && totalParticipantes <= 100) {
                // Autorização por Diretor ou Gerente Geral UE
                participants_approval.status = 'pending';
                participants_approval.type = 'cod_funcao';
                participants_approval.values = '3003,4005,4007,3002';
              } else if (totalParticipantes > 100) {
                // Autorização por Vice-Presidente.
                participants_approval.status = 'pending';
                participants_approval.type = 'cod_funcao';
                participants_approval.values = '3002';
              }
            }
          } else {
            if (totalParticipantes > maxMembersByProfile) {
              setLoading(false);

              return toast.error(`Você não pode inserir mais de ${maxMembersByProfile} participantes nessa ação.`, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }

            if (actualTask?.participants_approval?.status) {
              participants_approval.status = actualTask?.participants_approval?.status;
            }

            if (actualTask?.participants_approval?.type) {
              participants_approval.type = actualTask?.participants_approval?.type;
            }

            if (actualTask?.participants_approval?.values) {
              participants_approval.values = actualTask?.participants_approval?.values;
            }
          }
        } else {
          if (taskStep?.status === 'open') {
            delete actualTask.maxPlayersNumber;

            if (totalParticipantes <= maxMembersWithoutApproval) {
              participants_approval.status = 'autoApproved';
            } else if (totalParticipantes >= 21 && totalParticipantes <= 30) {
              // Autorização por RO 3GUE, 2GUT, 2GCA, 2GUA
              participants_approval.status = 'pending';
              participants_approval.type = 'ro';
              participants_approval.values = '3GUE,2GUT,2GCA,2GUA,2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
            } else if (totalParticipantes >= 31 && totalParticipantes <= 50) {
              // Autorização por RO 2GUE, 1GUT, 1GUA ou 1GCA
              participants_approval.status = 'pending';
              participants_approval.type = 'ro';
              participants_approval.values = '2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
            } else if (totalParticipantes >= 51 && totalParticipantes <= 100) {
              // Autorização por Diretor ou Gerente Geral UE
              participants_approval.status = 'pending';
              participants_approval.type = 'cod_funcao';
              participants_approval.values = '3003,4005,4007,3002';
            } else if (totalParticipantes > 100) {
              // Autorização por Vice-Presidente.
              participants_approval.status = 'pending';
              participants_approval.type = 'cod_funcao';
              participants_approval.values = '3002';
            }
          } else {
            if (totalParticipantes > maxMembersByProfile) {
              setLoading(false);

              return toast.error(`Você não pode inserir mais de ${maxMembersByProfile} participantes nessa ação.`, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }

            participants_approval.status = 'autoApproved';
          }
        }

        await updateTaskEcoa({
          ...actualTask,
          team,
          title,
          indicator: {
            nome: indicator?.label || undefined,
            cod: indicator?.value || undefined,
          },
          start: { $date: new Date(periodStart).getTime() },
          end: { $date: new Date(periodEnd).getTime() },
          nec: selectedNec?.value,
          description: message,
          status: userInfo.ecoa !== 'INTEGRANTE' ? actualTask.status : 'aguardando',
          original_manager: initialManager._id,
          result: resultMessage,
          participants_approval,
        });
      } else {
        const serverTime = await getServerTime();

        if (
          !currentCycle?.status ||
          currentCycle.status !== 'open' ||
          serverTime > currentCycle.date_finish ||
          serverTime < currentCycle.date_start
        ) {
          return toast.error(`Não há fase disponível para envio de realizações.`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }

        const data = await submitTaskEcoa({
          owner: user?._id,
          owner_cad_missao: userInfo?.cad_missao,
          owner_cod_etapa: userInfo?.cod_etapa,
          owner_funcao_localizacao: userInfo?.funcao_localizacao,
          team,
          start: { $date: new Date(periodStart).getTime() },
          end: { $date: new Date(periodEnd).getTime() },
          nec: selectedNec.value,
          title,
          indicator: {
            nome: indicator?.label || undefined,
            cod: indicator?.value || undefined,
          },
          description: message,
          status: 'aguardando',
          original_manager: initialManager._id,
          result: resultMessage,
          ecoa: true,
        });

        if (!data._id && data?.message) {
          setSubmitError(data.message);
        }
      }

      console.log('fim do submit');
      setLoading(false);
      setSubmitted(true);
      refreshUser();
    } catch (e) {
      setLoading(false);
    }
  }

  function removerTagsP(texto: string): string {
    const regex = /<p[^>]*>|<\/p>|\n|&nbsp;/gi;
    const textoSemTagsP = texto.replace(regex, '');

    return textoSemTagsP;
  }

  function removeTarget(index: number) {
    if (target && target.length) {
      const newTargetList = [...target];
      newTargetList.splice(index, 1);
      setTarget(newTargetList);
    }
  }

  const extractKeys = (data: any) => {
    const keys = [];

    if (data) {
      keys.push(data.chave);

      Object.keys(data).forEach(key => {
        if (key.startsWith('gestor') && key !== 'gestor1') {
          keys.push(data[key].chave);
        }
      });
    }

    return keys;
  };

  function addTarget(item: User) {
    const isOnTarget = target?.find((e: User) => e._id === item._id);

    focusOnElement('.currentAction input');

    if (!!isOnTarget) {
      setShowModalAlert('Esse funcionário já está na lista de participante da ação.');
      return;
    }
    const isInvalided = userInfo?.gestores?.find((e: string) => e === item._id);

    const gestoresByOwner = extractKeys(currentTask?.gestores);

    const isInvalidedByOwner = gestoresByOwner.find((e: string) => e === item._id);

    const ineligible = ineligibleIdsArray.find(e => e === item?.extra?.cod_funcao);

    // if (!!isInvalided || !!isInvalidedByOwner) {
    //   setShowModalAlert('Esta pessoa não pode ser indicada nesta ação, pois ela faz parte do fluxo de apreciação desta entrega.');
    //   return;
    // }

    if (['TUTOR', 'COORDENADOR'].includes(item?.extra?.ecoa)) {
      setShowModalAlert('É vedada a inclusão de Coordenador e Tutor. Consulte a IN 403-1 item 7.4.6.4.4.2.5.');
      return;
    }

    // if (!!ineligible) {
    //   setShowModalAlert('Essa pessoa não pode ser indicada em Ações ECOA.');
    //   return;
    // }

    if (!item.canAddUser) {
      if (!usersNotification || !usersNotification.length || !usersNotification?.find((e: string) => e === item._id)) {
        const payload = {
          target: item._id,
          user: userInfo?.chave,
          fase: currentCycle?._id,
          created: { $date: new Date().getTime() },
        };

        sendNotificationTask(payload);
        setUsersNotification([...usersNotification, item._id]);
      }
      setShowModalAlert('Esse funcionário não pode ser adicionado a esta ação.');
      return;
    }

    if (item?.extra?.actions === false) {
      if (
        !usersNotificationPreference ||
        !usersNotificationPreference.length ||
        !usersNotificationPreference?.find((e: string) => e === item._id)
      ) {
        setUsersNotificationPreference([...usersNotificationPreference, item._id]);

        const payload = {
          target: item._id,
          user: userInfo?.chave,
          item: 'action',
          created: { $date: new Date().getTime() },
        };

        sendPreferenceNotification(payload);
      }
      setShowModalAlert(`${item?.extra?.nome_guerra} optou, em "Minhas Preferências", pela não participação nesta dinâmica.`);
      return;
    }

    const newTargetList = target || [];
    newTargetList.push(item);
    setTarget(newTargetList);
    setSearchResults([]);
    setSearching(false);
    if (searchRef && searchRef.current) {
      searchRef.current.value = '';
    }
    if (teamApproval().showAlert) {
      setOpenTargetAlert(true);
    }
  }

  function reset() {
    setTarget(undefined);
    setSubmitted(false);
    setLoading(false);
    setSubmitError(undefined);
    setSearchResults([]);
    setSearching(false);
    setMessage(undefined);
    setResultMessage(undefined);
    setTitle(undefined);
    setPeriodStart(undefined);
    setPeriodEnd(undefined);
    setNec(undefined);
    setIndicator(undefined);
    setStep(0);
    setTeamDistribution(undefined);
  }

  function handleCloseModal() {
    reset();
    navigate('../', { state: { direction: 'back' } });
    // lastFocusedElementRef.current?.focus();
    // document.removeEventListener('keydown', trapFocus);
  }

  const handleDemandanteChange = (e: any) => {
    if (selectedNec.value.cd_alcc === '123456789') {
      setDemandanteValue(e);
      selectedNec.value.nm_uor_sltt = e.value;
    }
  };

  function validateInput(e: any) {
    if (e.value > 100) {
      e.value = 100;
    } else if (e.value < 0) {
      e.value = 0;
    } else if (e.value === '') {
      e.value = 0;
    }

    const teamMember = e.id.replace('team_player_', '');

    setTeamDistribution({ ...teamDistribution, [teamMember]: e.value });
  }

  const isValidDistribution: boolean = useMemo((): boolean => {
    if (!target?.length || !Object.keys(teamDistribution).length) return false;

    for (let index = 0; index < target.length; index++) {
      const teamItem = teamDistribution[target[index]._id];

      if (!teamItem || isNaN(Number(teamItem)) || Number(teamItem) <= 0) {
        return false;
      }
    }

    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, teamDistribution, searchResults]);

  const isValidDistributionMessage: boolean = useMemo((): boolean => {
    if (!target?.length) return false;

    for (let index = 0; index < target.length; index++) {
      const teamItem = target[index];

      if (
        !teamItem.message ||
        !teamItem.messageLength ||
        teamItem.messageLength.textLength < minMessageTarget ||
        teamItem.messageLength.fullLength > maxMessageTarget
      ) {
        return false;
      }
    }

    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, searchResults]);

  function validateDistribution(team: any) {
    if (team) {
      let valid = true;
      const updatedTeam = [...team];
      const distribution = updatedTeam.map((item: any, index: number) => {
        try {
          const teamInput: any = teamDistribution[item._id] || 0;
          if (isNaN(teamInput) || teamInput > 100 || teamInput <= 0) {
            valid = false;
          }
          return { ...item, percent: parseInt(teamInput) };
        } catch (e) {
          console.log(e);
          valid = false;
          return { ...item };
        }
      });

      if (valid) {
        return distribution;
      } else {
        return team;
      }
    } else {
      return [];
    }
  }

  function getUserDistribution(_id: string) {
    try {
      return teamDistribution[_id];
    } catch (e) {
      return 0;
    }
  }

  function handleChangeTitle(content: string, contentLength: any) {
    setTitle(removerTagsP(content));
    setTitleLength(contentLength);
  }

  function handleChangeMessage(content: string, contentLength: any) {
    setMessage(removerTagsP(content));
    setMessageLength(contentLength);
  }

  function handleChangeResult(content: string, contentLength: any) {
    setResultMessage(removerTagsP(content));
    setResultLength(contentLength);
  }

  function handleChangeMessageTarget(content: string, contentLength: any, index: number) {
    const newTarget = target ? [...target] : [];
    newTarget[index].message = content;
    newTarget[index].messageLength = contentLength;
    setTarget(newTarget);
  }

  async function loadNecs(nec?: string) {
    const necs = await getNecs(nec);
    setNecsList(necs);

    return necs;
  }

  function getPositionLabel() {
    try {
      return (
        <div className="p-1 text-left text-white text-sm font-thin">
          <p>
            Caso não exista Necessidade de TI vinculada, escreva a sequência "123456789". Será obrigatório preencher o campo
            demandante.
          </p>
        </div>
      );
    } catch (e) {
      return `---`;
    }
  }

  useEffect(() => {
    async function loadData() {
      const result = await getTaskByIdEcoa(params.id);

      if (result && userInfo) {
        setCurrentTask(result);
        setEditing(true);

        const resp = await getPlayerInfo('F' + result?.original_manager?.padStart(7, '0'));
        if (resp) {
          setInitialManager(resp);
        }

        if (!!result?.maxPlayersNumber) {
          setMaxMembers(result.maxPlayersNumber as number);
        }

        setIndicatorsList(indicadores);

        const isOwnerOnTeam: any = result.team.find((item: any) => item._id === user?._id);

        if (!isOwnerOnTeam && userInfo.ecoa === 'INTEGRANTE') {
          result.target.push({
            _id: user?._id,
            name: user?.name,
            extra: user?.extra,
          });
          result.team.push({
            _id: user?._id,
          });
        }

        const currentTeam = result.target.sort((a: any, b: any) => (a._id === user?._id ? -1 : 1)); // = result.target.filter((item:any)=>item._id !== user?._id);
        const currentDistribution = result.team.reduce((value: any, item: any) => {
          value[item._id] = item.percent;
          return value;
        }, {});

        currentTeam.map((item: any) => {
          item.message = result?.team?.find((x: any) => x._id === item._id)?.message;
          return item;
        });

        setTarget(currentTeam);
        setTeamDistribution(currentDistribution);
        setMessage(result.description);
        setResultMessage(result.result);
        setTitle(result.title);
        setDemandanteValue(
          result.nec && result.nec.cd_alcc === '123456789'
            ? {
                label: result.nec.nm_uor_sltt,
                value: result.nec.nm_uor_sltt,
              }
            : result.nec && result.nec.cd_alcc !== '123456789'
              ? result.nec.nm_uor_sltt
              : undefined,
        );
        const selectNec = await defineSelectedNec(result);
        setSelectedNec(selectNec);
        setIndicator(
          result.indicator
            ? {
                label: result.indicator.nome,
                value: result.indicator.cod,
              }
            : undefined,
        );

        try {
          setPeriodStart(format(utcToZonedTime(result.start, 'GMT'), 'yyyy-MM-dd'));
          setPeriodEnd(format(utcToZonedTime(result.end, 'GMT'), 'yyyy-MM-dd'));
        } catch (e) {
          console.log(e);
        }

        const date = new Date(result.created);

        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

        setMaxDate(format(lastDay, 'yyyy-MM-dd'));
        setMinDate(format(firstDay, 'yyyy-MM-dd'));
      }

      setLoading(false);
    }

    async function loadUors() {
      const uors = await getUors(userInfo?.uor_trabalho);
      setNeedNec(uors);
    }

    async function loadDemandates() {
      const demandantes = await getDemandantes();
      setDemandanteList(demandantes);
    }

    async function loadUserBySearch() {
      // const listLinkedIndicators = await getLinkedIndicators();

      setIndicatorsList(indicadores);

      // loadVerifyTask(listLinkedIndicators?.indicadores);

      const currentTime = await getServerTime();

      const date = new Date(currentTime);

      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

      setMaxDate(format(lastDay, 'yyyy-MM-dd'));
      setMinDate(format(firstDay, 'yyyy-MM-dd'));

      const result = await findPlayer(user?._id, true);

      setTarget(result);
    }

    async function getInfoGestor() {
      const result = await getPlayerInfo('F' + userInfo?.ecoa_idgestor?.padStart(7, '0'));
      if (result) {
        setInitialManager(result);
      }
    }

    async function loadVerifyTask(indicadores?: LinkedIndicators_Indicadores[]) {
      const data = await verifyTask(params.id);

      if (data && data?.total && data?.total > 0 && indicadores?.length && indicadores?.length > 1) {
        setHasOtherType(true);
      }
    }

    if (user && userInfo) {
      if (params && params.id && params.id !== 'cadastrar') {
        loadData();
      } else {
        loadUserBySearch();
        getInfoGestor();
      }

      // loadNecs();
      // loadUors();
      // loadDemandates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, user, userInfo]);

  const periodStartIsValid: boolean = useMemo((): boolean => isPeriodStartValid(periodStart), [periodStart]);

  const periodEndIsValid: boolean = useMemo(
    (): boolean => isPeriodEndValid(periodStart, periodEnd, maxDate),
    [periodStart, periodEnd, maxDate],
  );

  const loadNec = async (necId: string) => {
    let necByLoad: any = await getNecs(necId);
    return necByLoad.length > 0 ? necByLoad[0] : null;
  };

  const defineSelectedNec = async (result: any) => {
    if (typeof result.nec === 'string') {
      const nec = await loadNec(result.nec);
      if (nec) {
        setDemandanteValue(nec.nm_uor_sltt);
        return {
          label: nec.cd_alcc + ' - ' + nec.nm_alcc,
          value: nec,
        };
      } else {
        return {
          label: '123456789 - SEM NEC VINCULADA',
          value: { cd_alcc: '123456789', nm_alcc: 'SEM NEC VINCULADA' },
        };
      }
    } else if (result.nec) {
      return {
        label: result.nec.cd_alcc + ' - ' + result.nec.nm_alcc,
        value: result.nec,
      };
    } else {
      return undefined;
    }
  };

  const dotsText = [
    'Até 20: Liberação automática;',
    'De 21 a 30: 3º nível gerencial de UE ou 2º nível de UT, UA ou CA;',
    'De 31 a 50: 2º nível gerencial de UE ou 1º nível de UT, UA ou CA;',
    'De 51 a 100: Diretor ou Gerente Geral UE;',
    'Acima de 100: Vice-Presidente.',
  ];

  function textRecomendation() {
    return (
      <div className="font-normal text-sm mt-4">
        {dotsText.map((text, index) => (
          <p key={text}>
            <span className="dots">&#8226;&nbsp;</span>
            {text}
          </p>
        ))}
      </div>
    );
  }

  let searchTimer: ReturnType<typeof setTimeout>;

  const timeoutDelay = 500;

  const handleInputChange = (e: any) => {
    if (searchTimer) {
      clearTimeout(searchTimer);
    }

    searchTimer = setTimeout(() => {
      loadNecs(e);
    }, timeoutDelay);
  };
  const buttonContinueIsDisabled = () => {
    return (
      (step === 0 && !target?.length) ||
      (step === 1 &&
        (!title?.length ||
          !periodStart?.length ||
          !periodEnd?.length ||
          !indicator?.label ||
          !indicator?.value ||
          !periodStartIsValid ||
          !periodEndIsValid ||
          !initialManager?._id ||
          new Date(periodEnd) < new Date(periodStart) ||
          !titleLength ||
          titleLength?.textLength < minTitleLength ||
          titleLength?.fullLength > maxTitleLength)) ||
      (step === 2 &&
        (!message ||
          !resultMessage ||
          !messageLength ||
          messageLength?.textLength < minMessageLength ||
          messageLength?.fullLength > maxMessageLength ||
          !resultLength ||
          resultLength?.textLength < minResultLength ||
          resultLength?.fullLength > maxResultLength))
    );
  };

  function changeValue(id: string, value: number) {
    const input: any = document.getElementById(id);
    const newValue = value;
    input.value = newValue;

    validateInput(input);
  }

  useEffect(() => {
    if (step) {
      toNextStepFocus();
    }

    setAriaLabel(`Etapa ${step + 1} de 3 para cadastrar ação ecoa`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  useEffect(() => {
    async function playerCanView() {
      const serverTime = await getServerTime();

      if (
        !currentCycle?.status ||
        currentCycle.status !== 'open' ||
        serverTime > currentCycle.date_finish ||
        serverTime < currentCycle.date_start
      ) {
        toast.error(`Não há fase disponível para envio de realizações.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        return navigate('../');
      }
    }

    if (!!currentCycle && params && params.id && params.id === 'cadastrar') {
      playerCanView();
    }
  }, [currentCycle, navigate, params]);

  if (!userInfo) return null;

  const handleChangeNec = (selectedOption: any) => {
    setSelectedNec(selectedOption);

    if (selectedOption.value.cd_alcc === '123456789') {
      setShowDemandante(true);
      setDemandanteValue('');
    } else {
      setShowDemandante(false);
      setDemandanteValue(selectedOption.value.nm_uor_sltt);
    }
  };

  if (
    typeof params.id !== `string` ||
    typeof userInfo.ecoa !== `string` ||
    // userInfo.ecoa === 'INTEGRANTE' ||
    ((userInfo.ecoa === 'TUTOR' || userInfo.ecoa === 'COORDENADOR') && params.id === 'cadastrar') ||
    !!userInfo.visualizador
  ) {
    return null;
  }

  if (currentCycle?._id === '68af4da8458e527eaa788503') {
    return null;
  }

  function focusOnElement(selector: string) {
    const element: any = document.querySelector(selector);
    if (!!element) {
      element?.focus();
    }
  }

  // function afterOpenModal() {
  //   lastFocusedElementRef.current = document.activeElement as HTMLElement;
  //   const focusableElementsString =
  //     'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], [contenteditable]';
  //   const focusableElements = modalRef.current?.querySelectorAll(focusableElementsString);
  //   const firstFocusableElement = focusableElements ? (focusableElements[0] as HTMLElement) : null;
  //   firstFocusableElement?.focus();

  //   document.addEventListener('keydown', trapFocus);
  // }

  // function trapFocus(event: KeyboardEvent) {
  //   const focusableElementsString =
  //     'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]';
  //   const focusableElements = modalRef.current?.querySelectorAll(focusableElementsString);
  //   if (focusableElements) {
  //     const firstFocusableElement = focusableElements[0] as HTMLElement;
  //     const lastFocusableElement = focusableElements[focusableElements.length - 1] as HTMLElement;

  //     if (event.key === 'Tab') {
  //       if (event.shiftKey) {
  //         if (document.activeElement === firstFocusableElement) {
  //           lastFocusableElement.focus();
  //           event.preventDefault();
  //         }
  //       } else {
  //         if (document.activeElement === lastFocusableElement) {
  //           firstFocusableElement.focus();
  //           event.preventDefault();
  //         }
  //       }
  //     }
  //   }
  // }

  function toNextStepFocus() {
    focusOnElement('.informativeSteps div');
  }

  if (user?.extra?.actions === false && userInfo?.ecoa !== 'TUTOR') return null;

  return (
    <ReactModal
      key={'modal-create-task'}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      // onAfterOpen={afterOpenModal}
      onAfterClose={handleCloseModal}
      contentLabel="Modal Entrega"
      portalClassName="modal-create-mission"
      overlayClassName="fixed z-20 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
      contentElement={() => (
        <ModalAcessivel isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
          {!submitted && (
            <Box className="relative bg-oxford-blue border-electric-blue py-8 px-5 lg:pl-16 flex flex-col w-[90%] lg:max-w-screen-md justify-center items-center border-opacity-100 bg-opacity-100">
              <button
                aria-label="Fechar modal"
                className="absolute -top-5 -right-5 button-close bg-slate-blue rounded-full p-1"
                onClick={() => {
                  if (searchResults.length > 0) {
                    reset();
                  } else {
                    setIsOpen(false);
                  }
                }}
              >
                <IoClose size={30} className="text-white" />
              </button>

              <div className="mx-auto relative container overflow-y-auto overflow-x-hidden max-h-[85vh] pr-8">
                <div className="block mb-8">
                  <h3
                    className="text-lg uppercase block text-center text-yellow"
                    tabIndex={0}
                    aria-label={`Modal  ${params.id && params.id !== 'cadastrar' ? 'Editar' : 'Cadastrar'} Ação Ecoa`}
                  >
                    {params.id && params.id !== 'cadastrar' ? 'Editar' : 'Cadastrar'} Ação Ecoa
                  </h3>
                </div>
                {!loading && !submitted && (
                  <div className="informativeSteps space-y-4">
                    <div className="relative flex flex-row items-center justify-around" tabIndex={0} aria-labelledby="steps">
                      <p className="hidden" id="steps">
                        {ariaLabel}
                      </p>
                      <div className="absolute z-0 w-full h-[1px] top-0 bottom-0 m-auto border-b border-white opacity-20"></div>
                      <div
                        aria-hidden={true}
                        className={`${
                          step === 0 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        1
                      </div>
                      <div
                        aria-hidden={true}
                        className={`${
                          step === 1 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        2
                      </div>
                      <div
                        aria-hidden={true}
                        className={`${
                          step === 2 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        3
                      </div>
                    </div>

                    {step === 0 && (
                      <div className="space-y-6">
                        <div className="space-x-4 flex flex-row items-center justify-between w-full">
                          <div className="relative flex-1">
                            <span className="text-alice-blue mb-4 block text-base font-thin" tabIndex={0}>
                              Inclua os membros da Ecoa que efetivamente atuaram com você nesta ação.
                            </span>
                            {!!(!target?.length || !teamApproval().blockAdd) && (
                              <div>
                                <div className="space-x-4 flex flex-row items-center justify-between">
                                  <form onSubmit={handleSearch} className="pl-1 flex-1">
                                    <InputMask
                                      placeholder="Digite o nome ou chave do funcionário"
                                      alwaysShowMask={false}
                                      mask={mask}
                                      ref={(ref: any) => {
                                        searchRef.current = ref;
                                      }}
                                      onChange={e => handleChange()}
                                      inputMode="search"
                                      style={{ fontSize: 16 }}
                                      className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                      aria-label="Campo de busca. Em branco. Campo editável.
                                                  Observação: Você pode adicionar até 12 pessoas
                                                  nesta ação. Insira apenas colegas que
                                                  efetivamente participaram da entrega."
                                    />
                                  </form>

                                  <button tabIndex={0} aria-label="Buscar funcionário" onClick={() => handleSearch()}>
                                    <TbSearch size={28} className="cursor-pointer hover:ring-2 mr-1 rounded-full" />
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {!searching && isAlreadySelectedInList && (
                          <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl">
                            <div className="text-center pt-2 text-white font-base font-light">
                              Esse usuário já foi inserido na lista de participantes.
                            </div>
                          </div>
                        )}

                        {!!searchResults && searchResults.length > 0 && (
                          <>
                            <div className="flex-1 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl h-[30vh] lg:h-auto overflow-y-auto lg:overflow-y-visible">
                              {searchResults.map((item, index) => (
                                <button
                                  key={item._id}
                                  onClick={() => addTarget(item)}
                                  aria-label={`${item.name}. Chave ${item._id}. ${
                                    item.extra?.diretoria && 'Lotado ' + item.extra?.diretoria
                                  }`}
                                  className={`cursor-pointer hover:opacity-75 w-full flex flex-row items-center justify-between border-b border-prussian-blue pb-4 mb-4 text-left`}
                                >
                                  <div className="w-[44px] h-[44px] ml-2">
                                    <UserAvatar
                                      data={{
                                        image: item.image,
                                        ...item.extra,
                                      }}
                                    />
                                  </div>
                                  <p className="flex-1 pl-3 pr-2 w-3/5">
                                    <span className="text-xs font-thin">
                                      <strong className="text-base font-semibold">{item.extra?.nome_guerra}</strong> ({item._id})
                                    </span>
                                    <span className="block text-xs font-thin">{item.name}</span>
                                    {!!item.extra?.diretoria || !!item.extra?.funcao ? (
                                      <span className="block text-xs font-thin">
                                        {!!item.extra?.diretoria && (
                                          <span className="text-electric-blue uppercase">{item.extra?.diretoria}</span>
                                        )}
                                        {!!item.extra?.diretoria && !!item.extra?.funcao && ' - '}
                                        {item.extra?.funcao ? `${item.extra?.funcao}` : ''}
                                      </span>
                                    ) : null}
                                  </p>
                                </button>
                              ))}

                              {/* <div className="text-center pt-2 text-white font-base font-light">
                                Não encontrou quem procura? Experimente buscar por nome e sobrenome ou matrícula.
                              </div> */}
                            </div>
                          </>
                        )}

                        {!searching && isEmptyName && (
                          <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl">
                            <div className="text-center pt-2 text-white font-base font-light">
                              O funcionário que procura não é membro ECOA.
                            </div>
                          </div>
                        )}

                        {target && target?.length > 0 && !searching && (
                          <>
                            <div>
                              {target?.length && (
                                <p
                                  className="block text-sm text-white font-bold"
                                  tabIndex={0}
                                  aria-label={`Total de participantes: ${target?.length}`}
                                >
                                  Total de participantes: {target?.length}
                                </p>
                              )}
                            </div>
                            <div className="flex-1 bg-rich-black bg-opacity-80 py-4 px-2 lg:px-8 rounded-3xl">
                              {target.map((item: User, index: number) => (
                                <div
                                  key={item._id}
                                  className={`w-full flex flex-col justify-between gap-4 ${
                                    index + 1 < target.length ? 'border-b border-prussian-blue pb-4 mb-4 ' : ''
                                  }`}
                                  onClick={() => console.log(item)}
                                >
                                  <div className="flex flex-1 relative">
                                    <div className="flex flex-row">
                                      <div className="w-[44px] h-[44px] ml-2">
                                        <UserAvatar
                                          data={{
                                            image: item.image,
                                            ...item.extra,
                                          }}
                                        />
                                      </div>
                                      <p className="flex-1 pl-3 pr-2 max-w-xs">
                                        <span
                                          className="text-xs font-thin"
                                          tabIndex={0}
                                          aria-label={`${item.name}. chave ${item._id}`}
                                        >
                                          <strong className="text-base font-semibold truncate w-[35vw] text lg:w-auto block">
                                            {item.extra?.nome_guerra}
                                          </strong>{' '}
                                          <span className="block text-xs font-thin">{item.name}</span>
                                          {item._id}{' '}
                                          {!!item.extra?.diretoria && (
                                            <span className="text-electric-blue uppercase">- {item.extra?.diretoria}</span>
                                          )}
                                          {!!item.extra?.diretoria && !!item.extra?.funcao && ' - '}
                                          {item.extra?.funcao ? `${item.extra?.funcao}` : ''}
                                        </span>
                                      </p>
                                    </div>
                                    {user?._id !== item._id && item?._id !== currentTask?.owner && (
                                      <RiCloseLine
                                        size={44}
                                        className="cursor-pointer hover:ring-2 p-2 rounded-full text-slate-blue absolute right-0  "
                                        onClick={() => removeTarget(index)}
                                      />
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {/* {isEmpty && !searching && (
                          <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl">
                            <div className="text-center pt-2 text-white font-base font-light">
                              Verifique a matrícula que você está buscando, essa matrícula não consta na base de funcionário do
                              Joga Junto.
                            </div>
                          </div>
                        )} */}

                        {searching && (
                          <div className="flex-1 bg-rich-black bg-opacity-80 p-8 rounded-3xl">
                            <p className="animate-pulse text-yellow">Recuperando informações...</p>
                          </div>
                        )}
                      </div>
                    )}

                    {step === 1 && (
                      <>
                        <div className="border-2 border-electric-blue rounded-2xl p-8 flex flex-col w-full space-y-4 lg:space-y-6">
                          <div
                            className="text-white text-lg lg:text-lg block leading-none font-semibold"
                            tabIndex={0}
                            aria-label="Informações da entrega"
                          >
                            Informações da Ação Ecoa
                          </div>

                          <div ref={ref => (titleRef.current = ref)}>
                            <label className="text-white font-thin text-xs leading-none mb-2 block">Nome da ação</label>
                            <TextEditor
                              disableEmoji
                              initialValue={title}
                              maxLength={maxTitleLength}
                              minLength={minTitleLength}
                              onChange={handleChangeTitle}
                              className="w-full text-white py-2 rounded-md leading-none text-sm font-light"
                            />
                          </div>

                          <div>
                            <label
                              tabIndex={0}
                              aria-label="Informar Eixo Temático ligado a ação ecoa. "
                              className="text-white font-thin text-xs leading-none mb-2 block"
                            >
                              Eixos Temáticos
                            </label>
                            <CustomSelect
                              className="select-realizacao-destaque"
                              aria-label="Expandir caixa de seleção para mostrar opções de eixos temáticos."
                              value={indicator}
                              placeholder="Selecione o eixos temáticos ligado a Ação Ecoa"
                              options={
                                indicatorsList
                                  ? indicatorsList.map((item, index: number) => {
                                      return {
                                        label: item.nome,
                                        value: item.cod,
                                      };
                                    })
                                  : [
                                      {
                                        label: 'Carregando...',
                                        value: '',
                                      },
                                    ]
                              }
                              onChange={(e: any) => [setIndicator(e)]}
                            />
                          </div>

                          <div className="w-full flex flex-col lg:flex-row lg:space-x-8 space-y-4 lg:space-y-0">
                            <div className="lg:w-1/2">
                              <label
                                tabIndex={0}
                                aria-label="Informar Data de início da entrega. Em branco. Campo editável"
                                className="text-white font-thin text-xs leading-none mb-2 block"
                              >
                                Início da ação
                              </label>
                              <input
                                type="date"
                                aria-label="Definir data de início da entrega.
                                            Abre modal com um calendário."
                                defaultValue={periodStart}
                                min={PERIOD_START_MIN}
                                max={maxDate}
                                ref={ref => (periodStartRef.current = ref)}
                                onChange={e => setPeriodStart(format(utcToZonedTime(e.target.value, 'GMT'), 'yyyy-MM-dd'))}
                                className="w-full bg-maastricht-blue text-white text-sm font-light py-2 px-4 rounded-md leading-none"
                              />
                            </div>

                            <div className="lg:w-1/2">
                              <label
                                tabIndex={0}
                                aria-label="Informar Data do final da entrega. Em branco. Campo editável"
                                className="text-white font-thin text-xs leading-none mb-2 block"
                              >
                                Conclusão da ação
                              </label>
                              <input
                                aria-label="Definir data de início da entrega.
                                            Abre modal com um calendário."
                                defaultValue={periodEnd}
                                type="date"
                                min={PERIOD_END_MIN}
                                max={maxDate}
                                ref={ref => (periodEndRef.current = ref)}
                                onChange={e => setPeriodEnd(format(utcToZonedTime(e.target.value, 'GMT'), 'yyyy-MM-dd'))}
                                className="w-full bg-maastricht-blue text-white py-2 px-4 rounded-md leading-none text-sm font-light"
                              />
                            </div>
                          </div>

                          <div>
                            <label
                              className="text-white font-thin text-xs leading-none mb-2 flex items-center"
                              tabIndex={0}
                              aria-label={`Responsável pela apreciação: ${initialManager?.nome_guerra} (${initialManager?.chave}) - ${initialManager?.funcao}. Gerente de equipe. Campo editável. Essa pessoa é responsável por realizar a apreciação desta entrega?
Caso se faça necessário, você pode alterá-la no campo abaixo.`}
                            >
                              Responsável por apreciar a ação
                            </label>

                            <div className="flex space-x-3">
                              <form onSubmit={handleSearchManager} className="pl-1 flex-1">
                                <input
                                  value={
                                    !!initialManager && !!initialManager.nome_guerra
                                      ? `${initialManager.nome_guerra} (${initialManager.chave}) - ${initialManager.funcao}`
                                      : searchManager
                                  }
                                  disabled={!!initialManager}
                                  onChange={e => setSearchManager(e.target.value)}
                                  className={`text-white w-full bg-maastricht-blue py-2 px-4 rounded-md leading-none text-sm font-light`}
                                />
                              </form>

                              {!!initialManager ? (
                                <button onClick={() => setInitialManager(null)} aria-label="Alterar responsável por apreciação.">
                                  <AiOutlineEdit className="text-grey-dark" size={25} />
                                </button>
                              ) : (
                                <button onClick={() => handleSearchManager()} aria-label="Alterar responsável por apreciação.">
                                  <RiSearchLine className="text-grey-dark" size={25} />
                                </button>
                              )}
                            </div>

                            <span className="text-yellow text-xs mt-2 block">
                              Essa pessoa é responsável por realizar a apreciação desta entrega? Caso não seja ela, você pode
                              alterá-la, clicando no ícone acima.
                            </span>

                            {searching && (
                              <div className="mt-6 flex-1 bg-rich-black bg-opacity-80 p-8 rounded-3xl">
                                <p className="animate-pulse text-yellow">Recuperando informações...</p>
                              </div>
                            )}

                            {!!searchResultsManager && searchResultsManager.length > 0 && (
                              <div className="mt-4">
                                <p className="mb-5">Resultado da pesquisa:</p>
                                <div className="flex-1 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl h-[30vh] lg:h-auto overflow-y-auto lg:overflow-y-visible">
                                  {searchResultsManager.map(item => (
                                    <div
                                      key={item._id}
                                      onClick={() => {
                                        setInitialManager(item);
                                        setSearchResultsManager([]);
                                        setSearchManager('');
                                      }}
                                      className={`cursor-pointer hover:opacity-75 w-full flex flex-row items-center justify-between border-b border-prussian-blue pb-4 mb-4`}
                                    >
                                      <div className="w-[44px] h-[44px] ml-2">
                                        <UserAvatar
                                          data={{
                                            image: item.image,
                                            ...item,
                                          }}
                                        />
                                      </div>
                                      <p className="flex-1 pl-3 pr-2 w-3/5">
                                        <span className="block text-xs font-thin">
                                          <strong className="text-base font-semibold">{item.nome_guerra}</strong>
                                        </span>
                                        <span className="text-xs font-thin">
                                          {item.nome} ({item.chave})
                                        </span>
                                        {!!item?.diretoria || !!item?.funcao ? (
                                          <span className="block text-xs font-thin">
                                            {!!item?.diretoria && (
                                              <span className="text-electric-blue uppercase">{item?.diretoria}</span>
                                            )}
                                            {!!item?.diretoria && !!item?.funcao && ' - '}
                                            {item?.funcao ? `${item?.funcao}` : ''}
                                          </span>
                                        ) : null}
                                      </p>
                                    </div>
                                  ))}

                                  <div className="text-center pt-2 text-white font-base font-light">
                                    Não encontrou quem procura? Experimente buscar por nome e sobrenome ou matrícula.
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {!!title && !indicator?.value ? (
                          <p className="block font-light text-yellow">Você precisa selecionar um eixo temático para continuar.</p>
                        ) : null}

                        {!!periodStart?.length && !periodStartIsValid ? (
                          <p className="block font-light text-yellow">
                            A data de início da ação deve ser a partir de 01/01/2025. Altere para prosseguir.
                          </p>
                        ) : null}

                        {!!periodEnd?.length && !periodEndIsValid ? (
                          <p className="block font-light text-yellow">
                            A data da entrega deve estar entre 01/07/2024 e último dia deste mês. Altere para prosseguir.
                          </p>
                        ) : null}

                        {/* {hasOtherType && indicator?.value === 1 ? (
                          <p className="block font-light text-yellow">
                            Você não pode cadastrar mais de uma ação com o indicador "outros - ações estratégicas". Selecione
                            outro indicador para esta ação.
                          </p>
                        ) : null} */}

                        {!titleLength ||
                          titleLength?.textLength < minTitleLength ||
                          (titleLength?.fullLength > maxTitleLength && (
                            <p className="block font-light text-yellow">
                              O Nome da ação inserido ultrapassou o limite máximo de {maxTitleLength} caracteres.
                            </p>
                          ))}
                      </>
                    )}

                    {step === 2 && (
                      <div className="border-2 border-electric-blue rounded-2xl p-8 flex flex-col w-full space-y-2">
                        <div ref={ref => (messageRef.current = ref)} className="text-white text-sm leading-none block font-thin">
                          Detalhes da Ação Ecoa
                        </div>
                        <div className="flex flex-row items-center">
                          <div className="h-40 w-full bg-transparent">
                            <TextEditor
                              disableEmoji
                              initialValue={message}
                              maxLength={maxMessageLength}
                              minLength={minMessageLength}
                              onChange={handleChangeMessage}
                            ></TextEditor>
                          </div>
                        </div>
                        <p className="block text-sm text-white font-thin">
                          Na descrição, não se esqueça de demonstrar clareza e objetividade dos resultados e benefícios alcançados
                          por meio da sua ação ecoa.
                          <br />
                        </p>
                        <div className="text-white text-sm block font-thin pt-4">Resultados da Ação Ecoa</div>
                        <div className="flex flex-row items-center">
                          <div className="h-40 w-full bg-transparent">
                            <TextEditor
                              disableEmoji
                              initialValue={resultMessage}
                              maxLength={maxResultLength}
                              minLength={minResultLength}
                              onChange={handleChangeResult}
                            ></TextEditor>
                          </div>
                        </div>
                        <p className="block mt-2 text-sm text-yellow font-thin">
                          Atente-se quanto à classificação do sigilo das informações (IN 421), considerando que o conteúdo ficará
                          visível a todos os participantes.
                        </p>
                        {!messageLength ||
                          messageLength?.textLength < minMessageLength ||
                          (messageLength?.fullLength > maxMessageLength && (
                            <p className="block font-light text-yellow">
                              O Detalhes da Ação Ecoa inserido ultrapassou o limite máximo de {maxMessageLength} caracteres.
                            </p>
                          ))}
                        {!resultLength ||
                          resultLength?.textLength < minResultLength ||
                          (resultLength?.fullLength > maxResultLength && (
                            <p className="block font-light text-yellow">
                              O Detalhes da Ação Ecoa inserido ultrapassou o limite máximo de {maxResultLength} caracteres.
                            </p>
                          ))}
                      </div>
                    )}

                    <div className="flex lg:block justify-center">
                      <div className="p-2 px-45 flex flex-row space-x-8 items-center justify-center">
                        {step > 0 && (
                          <button
                            aria-label={`Voltar para a etapa ${step} de cadastramento de  ação ecoa`}
                            onClick={() => setStep(step - 1)}
                            className={`eading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Voltar</p>
                          </button>
                        )}
                        {step < 2 && (
                          <button
                            onClick={() => (!buttonContinueIsDisabled() ? setStep(step + 1) : null)}
                            disabled={buttonContinueIsDisabled()}
                            tabIndex={0}
                            aria-label={`Continuar para a etapa ${step + 2}.`}
                            className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Continuar</p>
                          </button>
                        )}
                        {step === 2 && (
                          <button
                            disabled={buttonContinueIsDisabled()}
                            onClick={() => handleSubmit()}
                            className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                            aria-label="Finalizar cadastramento de ação ecoa"
                            tabIndex={0}
                          >
                            <p className="font-bold text-sm leading-none uppercase">
                              {params.id && params.id !== 'cadastrar' ? 'Atualizar' : 'Finalizar'}
                            </p>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {loading && !submitted && (
                  <div className="space-y-4 mt-12">
                    <div className="flex flex-row items-center justify-center text-xl text-yellow animate-pulse">
                      <div></div>
                      Enviando Ação Ecoa...
                    </div>
                  </div>
                )}
              </div>
            </Box>
          )}

          {submitted && (
            <ModalAcessivel
              isOpen={submitted}
              onRequestClose={() => {
                setIsOpen(false);
              }}
            >
              <div className="border-2 rounded-3xl relative bg-oxford-blue border-electric-blue p-8 flex flex-col w-[324px] lg:max-w-screen-md justify-center items-center">
                <button
                  aria-label="Fechar modal"
                  className="absolute -top-5 -right-5 button-close"
                  onClick={() => {
                    setIsOpen(false);
                  }}
                >
                  <IoMdCloseCircle size={48} className="text-slate-blue" />
                </button>

                <div className="flex flex-col items-center justify-center">
                  {!submitError && (
                    <>
                      <div className="flex items-center justify-center mb-6">
                        <img src={FeedbackImg} alt="Enviado!" className="w-[173px] block" />
                      </div>
                      <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center" tabIndex={0}>
                        Mandou bem!
                      </h1>
                      <p className="text-sm font-white font-light text-center block" tabIndex={0}>
                        Sua Ação Ecoa foi {params.id && params.id !== 'cadastrar' ? 'atualizada' : 'cadastrada'}. Agora você
                        poderá acompanhar o processo de validação da entrega que será realizado pelo tutor.
                      </p>
                    </>
                  )}

                  {submitError && (
                    <>
                      <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center" tabIndex={0}>
                        Não deu pra enviar essa Ação Ecoa!
                      </h1>
                      <p className="text-sm font-white font-light text-center block mb-8" tabIndex={0}>
                        {submitError}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </ModalAcessivel>
          )}

          {showModalAlert && <Modal description={showModalAlert} onClose={() => setShowModalAlert(false)} />}
          {showModalTutorial && (
            <Modal
              onClose={() => {
                setshowModalTutorial(false);
              }}
              description={''}
            />
          )}
        </ModalAcessivel>
      )}
    />
  );
}
